import { create } from 'zustand';
import { HttpApi } from '@/common/http';
import {
  ENDPOINT_LAND_BY_ID,
  ENDPOINT_LAND_LIST,
  ENDPOINT_PROJECTS_POST,
} from '@/common/constants';
import { ILandById, ILands, IParams, TLands } from '../models/ILands';
import { IPageable } from '@/common/models';

const httpApi = new HttpApi();

const useLandStore = create<TLands>((set, get) => ({
  landListLoading: false,
  landList: {} as IPageable<ILands>,
  landById: {} as ILandById,
  landByIdLoading: false,
  landProjectLoading: false,
  fetchLands: async (params: IParams) => {
    set({ landListLoading: true });
    const res = await httpApi.get<IPageable<ILands>>(
      `${ENDPOINT_LAND_LIST}/${params.status || 'LAND'}`,
      params.query,
    );
    set({
      landList: res,
    });

    setTimeout(() => {
      set({ landListLoading: false });
    }, 300);
  },
  fetchLandById: async (params: { id: string }) => {
    set({ landByIdLoading: true });
    const res = await httpApi.get<ILandById>(
      `${ENDPOINT_LAND_BY_ID}/${params.id}`,
      {},
    );
    set({
      landById: res,
    });

    setTimeout(() => {
      set({ landByIdLoading: false });
    }, 300);
  },
  fetchLandProjects: async (params: any) => {
    set({ landProjectLoading: true });
    const res = await httpApi.post(ENDPOINT_PROJECTS_POST, params);
    setTimeout(() => {
      set({ landProjectLoading: false });
    }, 300);
  },
}));

export default useLandStore;
